import { meResponseSchema, type MeResponse } from '@avrahami/contracts';
import { isApiError, type ApiClient } from './api';

/** Where the browser's session stands, as the API sees it. */
export type SessionState =
  { kind: 'signed-out' } | { kind: 'mfa-pending' } | { kind: 'signed-in'; me: MeResponse };

export const SIGNED_OUT: SessionState = { kind: 'signed-out' };
export const MFA_PENDING: SessionState = { kind: 'mfa-pending' };

export function signedIn(me: MeResponse): SessionState {
  return { kind: 'signed-in', me };
}

/** Reads the session; "signed out" and "waiting for the second factor" are states, not errors. */
export async function fetchSession(client: ApiClient): Promise<SessionState> {
  try {
    return signedIn(await client.request('GET', '/v1/auth/me', meResponseSchema));
  } catch (error) {
    if (isApiError(error, 'MFA_REQUIRED')) return MFA_PENDING;
    if (isApiError(error, 'UNAUTHENTICATED') || isApiError(error, 'SESSION_EXPIRED')) {
      return SIGNED_OUT;
    }
    throw error;
  }
}
